import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgExternalLinkLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11 6C11.5523 6 12 6.44772 12 7C12 7.55228 11.5523 8 11 8H5V19H16V13C16 12.4477 16.4477 12 17 12C17.5523 12 18 12.4477 18 13V19C18 20.1046 17.1046 21 16 21H5C3.89543 21 3 20.1046 3 19V8C3 6.89543 3.89543 6 5 6H11ZM20 3C20.5523 3 21 3.44772 21 4V9C21 9.55228 20.5523 10 20 10C19.4477 10 19 9.55228 19 9V6.41421L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L17.5858 5H15C14.4477 5 14 4.55229 14 4C14 3.44772 14.4477 3 15 3H20Z",
		fill: "currentColor"
	})
});
export default SvgExternalLinkLine;
